import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
export default function PlaylistDeleteDialog({ en, busy, error, onClose, onDelete }) {
  return (
    <Dialog
      open
      fullWidth
      maxWidth="xs"
      className="pp-review-dialog"
      disableEscapeKeyDown={busy}
      onClose={() => {
        if (!busy) onClose();
      }}
      aria-labelledby="playlist-delete-title"
      aria-describedby="playlist-delete-message"
      PaperProps={{ role: 'alertdialog' }}
    >
      <DialogTitle id="playlist-delete-title">{en ? 'Delete Playlist' : '플리 삭제'}</DialogTitle>
      <DialogContent>
        <p id="playlist-delete-message">
          {en ? 'A deleted playlist cannot be recovered.' : '삭제한 플리는 복구할 수 없습니다.'}
        </p>
        {error && (
          <p role="alert">
            {en ? 'Could not delete. Please try again.' : '삭제하지 못했어요. 다시 시도해 주세요.'}
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus disabled={busy} onClick={onClose}>
          {en ? 'Cancel' : '취소'}
        </Button>
        <Button disabled={busy} onClick={onDelete}>
          {busy ? (en ? 'Deleting…' : '삭제 중…') : en ? 'Delete' : '삭제'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
